import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import { _get } from "../../../Utils/Helper";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/reducers";

interface TeacherSidebarProps {
  teacher_id: number | null;
}

const TeacherSidebar: React.FC<TeacherSidebarProps> = ({ teacher_id }) => {
  interface TeacherClass {
    class_name: string;
    subject: string;
    teacher_id: string;
    id: number;
  }
  interface TeacherData {
    id?: number;
    name: string;
    image: string;
    teacher_id: string;
    mobile_number: string;
    email?:string;
  }
  const _TeacherData: TeacherData = {
    name: "",
    image: "",
    teacher_id: "",
    mobile_number: "", // Corrected property name
  };
  const [teacherClasses, setTeacherClasses] = useState<TeacherClass[]>([]);
  const [teacher, setTeacher] = useState<TeacherData>(_TeacherData);
  const getTeacherClasses = () => {
    _get(
      `teachers?query_type=select-class&id=${teacher_id}`,
      (res) => {
        //   navigate(`/agent`)
        console.log(res);
        setTeacherClasses(res.results);
      },
      (err) => {
        // setLoading(false)
        console.log(err);
      }
    );
    // console.log(form)
  };

  const getTeacher = () => {
    _get(
      `teachers?query_type=select&id=${teacher_id}`,
      (res) => {
        //   navigate(`/agent`)
        console.log(res);
        setTeacher(res.results[0]);
      },
      (err) => {
        // setLoading(false)
        console.log(err);
      }
    );
    // console.log(form)
  };

  useEffect(() => {
    getTeacher();
    getTeacherClasses();
  }, []);

   const {user} = useSelector((state:RootState)=>state.auth)
    const [payments, setPayments] = useState([])
  
    useEffect(() => {
      if(user.role && user.role!=='Teacher'){
        _get(
          `teachers?query_type=select&id=${teacher_id||15}`,
        (res) => {
          setTeacher(res.results[0]);
        },
        (err) => {
          console.log(err);
        }
      );
    }else{
      setTeacher(user)
    }
    },[user.role]);
  return (
    <div className="col-xxl-3 col-xl-4 theiaStickySidebar">
      <div className="stickytopbar pb-4">
        <div className="card border-white">
          <div className="card-header">
            <div className="d-flex align-items-center flex-wrap row-gap-3">
              <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                <ImageWithBasePath
                  src="https://imageplaceholder.net/300"
                  className="img-fluid"
                  alt="img"
                />
              </div>
              <div>
                <h5 className="mb-1 mb-1 text-truncate">{teacher.name}</h5>
                <p>{teacher.mobile_number}</p>
              </div>
            </div>
          </div>
          <div className="card-body">
            <h5 className="mb-3">Responsibilities</h5>
            <table>
              <thead>
                <tr>
                  <th>Class</th>
                  <th>Subject</th>
                </tr>
              </thead>
              <tbody>
                {teacherClasses?.length
                  ? teacherClasses.map((x, idx) => (
                      <tr key={idx}>
                        <td>{x.class_name}</td>
                        <td>{x.subject}</td>
                      </tr>
                    ))
                  : null}
              </tbody>
            </table>
          </div>
        </div>
        <div className="card border-white">
          <div className="card-body">
            <h5 className="mb-3 ">Primary Contact Info</h5>
            <div className="d-flex align-items-center mb-3">
              <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                <i className="ti ti-phone" />
              </span>
              <div>
                <span className=" text-dark fw-medium mb-1">Phone Number</span>
                <p>{teacher.mobile_number}</p>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                <i className="ti ti-mail" />
              </span>
              <div>
                <span className="text-dark fw-medium mb-1">Email Address</span>
                <p>{teacher?.email}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="card border-white">
          <div className="card-body pb-1">
            <h5 className="mb-3">ID Number</h5>
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center mb-3">
                <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                  <i className="ti ti-id" />
                </span>
                <div>
                  <p className="text-dark">{teacher.id}</p>
                </div>
              </div>
              <Link to="#" className="btn btn-primary btn-icon btn-sm mb-3">
                <i className="ti ti-copy" />
              </Link>
            </div>
          </div>
        </div>
        <div className="card border-white mb-0">
          <div className="card-body pb-1">
            <ul className="nav nav-tabs nav-tabs-bottom mb-3">
              <li className="nav-item">
                <Link
                  className="nav-link active"
                  to="#hostel"
                  data-bs-toggle="tab"
                >
                  Classes
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="#transport" data-bs-toggle="tab">
                  Subjects
                </Link>
              </li>
            </ul>
            <div className="tab-content">
              <div className="tab-pane fade show active" id="hostel">
                <div className="d-flex align-items-center mb-3">
                  <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                    <i className="ti ti-building-fortress fs-16" />
                  </span>
                 {teacherClasses?.map((tc:any, idx:number)=> <div className="row" key={idx}>
                    <h6 className="mb-1">{tc.class_code}</h6>
                  </div>)}
                </div>
              </div>
              <div className="tab-pane fade" id="transport">
            
              {teacherClasses?.map((tc:any, idx:number)=> <div className="row" key={idx}>
                    <h6 className="mb-1">{tc.subject}</h6>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherSidebar;
